import { Fragment, useEffect, useState, useRef } from 'react'
import PageLayout from '../Layouts/PageLayout'
import Spinner from '../FieldComponets/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import { PAGES } from '../../Constants/CommonConstants';
import { MaterialReactTable } from 'material-react-table'
import { LinkButtons } from '../FieldComponets/LinkButtons';
import { paginationQuery, handleSearch } from '../../utils/GlobalHelper';
import type { ColumnFiltersState, PaginationState } from '@tanstack/react-table';
import React from 'react';
import { getDate } from '../../utils/Helper';
import { FaqlistGetAction ,FaqStatusChangesAction , FaqDeleteAction} from '../../Redux/Action/FaqAction';
import Swal from 'sweetalert2'
import { StorageConstant, VALIDATION_MESSAGE } from "../../Constants/Constants";

function FaqManagementList() {

  const dispatch = useDispatch<any>();

  const faqdata = useSelector((state: any) => state.FaqGetstate);
  const faqstatus = useSelector((state:any)=>state.FaqStatusstate)
  const faqDeletestatus = useSelector((state:any)=>state.FaqDeleteState)

  const [data, setData] = useState<any>([]);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [sorting, setSorting] = useState<any>(['ASC']);
  const formRef = useRef<HTMLFormElement>(null);

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: PAGES?.pageIndex,
    pageSize: PAGES?.pageSize
  });
  const [searchValue, setSearchValue] = useState('');
  const [rowCount, setRowCount] = useState(0);
  const [serachstatus, setSerachstatus] = useState<any>('')

  const handleFilterValue = (e: any) => {
    const { name, value } = e.target;
    setSerachstatus((prevStatus: any) => ({ ...prevStatus, [name]: value, }));
  };

  const handleStatusChange = (id:any)=>{
   const data ={
    status_id : id?.id,
    status:id.status == 1 ? 0 :1
   }
 dispatch(FaqStatusChangesAction(data))
  }


  const handeldelete = async (e: any) => {
        Swal.fire({
            title: VALIDATION_MESSAGE?.ARE_YOU_SURE,
            text: VALIDATION_MESSAGE?.FAQ_DELETE_TEXT,
            icon: 'warning',
            // showCancelButton: true,
            confirmButtonColor: '#31CE36',
            cancelButtonColor: '#d33',
            showDenyButton: true,
            denyButtonText: 'No',
            confirmButtonText: 'Yes',
        }).then(async (result) => {
            if (result.isConfirmed) {
                const data = {
                 delete_id:e?.id
                 
                };
                dispatch(FaqDeleteAction(data))
            }
        });
}
  // Table Coulmns
  const columns: any = [
    {
      accessorKey: 'S.NO',
      header: 'S.NO',
      accessorFn: (row: Object, index: number) => {
        const currentPage = pagination.pageIndex + 1 || 1; // Assuming current page number, default to 1 if not provided
        const itemsPerPage = pagination.pageSize || 10; // Assuming items per page, default to 10 if not provided
        const startIndex = (currentPage - 1) * itemsPerPage;
        const serialNumber = startIndex + index + 1;
        return serialNumber;
      },
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
      size: 50
    },
    {
      accessorKey: 'question',
      header: 'Question',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'answer',
      header: 'Answer',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'user_type',
      header: 'User Type',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      header: 'Status',
      size: 50,
      accessorFn: (row: { id: any, status: number }) => <>
        <div className="btn-group action-btn-table">
          <ul style={{ listStyleType: "none", marginLeft: "-24px" }}>
            <label className="switch">
              <input type="checkbox" checked={row.status == 1}  onChange={(e)=>handleStatusChange(row)} />
              <span className="slider round"></span>
            </label>
          </ul>
        </div>
      </>,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'created_at',
      header: 'Created At',
      accessorFn: (row: { created_at: any; }) => getDate(row.created_at),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: 'updated_at',
      header: 'Last Update on',
      accessorFn: (row: { updated_at: any; }) => getDate(row.updated_at),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      header: 'Action',
      size: 50,
      accessorFn: (row: { id: any; }) => <>
        <div className="btn-group action-btn-table">
          <ul style={{ listStyleType: "none", marginLeft: "-24px" }}>
            <span>
              <LinkButtons
                pageLink={`faq-edit`}
                pageID={row?.id}
                showEdit={true}
                showView={false}
                showDelete={false}
              />
            </span>
          </ul>
          <ul  style={{ listStyleType: "none", marginLeft: "-10px" }}>
          <span className="btn btn-danger-delete text-white" onClick={()=>handeldelete(row)} >
            <i  className="fas fa-trash-alt" title="Delete" ></i>
        </span>
          </ul>
        </div>
      </>,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (!data?.length) {
        setLoading(true);
      } else {
        setIsRefetching(true);
      }
      try {
        let query: any = paginationQuery(
          pagination.pageIndex,
          pagination.pageSize,
          sorting,
          searchValue,
          columnFilters
        );

        await dispatch(FaqlistGetAction(query));
        await dispatch(FaqStatusChangesAction("RESET"))

      } catch (error) {
        setIsError(true);
        return;
      }
      setIsError(false);
      setLoading(false);
      setIsRefetching(false);
    };
    fetchData();
  }, [
    columnFilters,
    searchValue,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    faqstatus.status,
    faqDeletestatus.status
  ]);
  useEffect(() => {
    setData(faqdata?.data?.data?.rows);
    setRowCount(faqdata?.data?.data?.count);
  }, [faqdata?.data]);
  const resetSearchfilter = () => {
   
    if (formRef.current) {
      formRef.current.reset();
    }
    const columnFilters = [
      { id: "question", value: "" },
    ]
    setColumnFilters(columnFilters)
    setSerachstatus({})

  }
  const handleserach = (e: any) => {
    e.preventDefault()
    const columnFilters = [
      { id: "question", value: serachstatus?.searchname?.trim() },
      { id: "user_type", value: serachstatus?.user_type},
    ]
    setColumnFilters(columnFilters)
  }
   const handleSearchBystatus = (Id: any) => {
    setColumnFilters([{ id: "user_type", value: Id }])
  }

  return (
    <Fragment>
      {(loading || faqdata?.loading) ? <Spinner /> : ""}

      <PageLayout
        title="Faq Management"
        breadcrumbs={{
          secLast: { 'link': '/faq-list', 'name': 'Faq Management' },
        }}
        buttons={[
          { url: '/faq-add', className: 'btn btn-success', text: 'Add New Faq', show: true }, // This button will be shown
        ]}
      >
           <form ref={formRef} onSubmit={handleserach}>
          <div className="row gy-3">
            <div className='col-md-6 col-lg-4 col-xl-3'>
              <label>Search</label>
              <div className="input-group w-100">
                <div className="input-group">
                  <span className="input-group-text fa-solid fa-magnifying-glass " id="basic-addon1"> <i className="fas fa-search"></i></span>
                  <input type='text' id="saerchId" className="form-control m-0" placeholder='Search by question' onChange={(e) => setSearchValue(e.target.value.trim())} />
                </div>
              </div>
            </div>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label> Users Type</label>
              <select className='form-select shadow-none' name="users" id="cars" onChange={(e) => handleSearchBystatus(e.target.value)}>
                <option value="">All Users</option>
                <option value="Salon">Salon</option>
                <option value="Customer">Customer</option>
              </select>
            </div>
            <div className='row gy-3 mt-3 mb-4'>
           
          </div>
            <div className="col-6">
              {/* <button className='btn theme-bg text-white me-2'>Filter</button> */}
              {/* <button className='btn btn-success' onClick={() => resetSearchfilter()} >Reset</button> */}
            </div>
          </div>
          
        </form>
        {
          data &&
          <MaterialReactTable
            columns={columns}
            data={data}
            enableGlobalFilter={false}

            enableHiding={false}
            enableColumnFilters={false}
            enableDensityToggle={false}
            enableColumnActions={false}
            enableFullScreenToggle={false}
            positionToolbarAlertBanner="top"
            initialState={{ showColumnFilters: false }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={isError ? { color: 'error', children: 'Error loading data', } : undefined}
            muiSearchTextFieldProps={{
              placeholder: 'Search from name',
            }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={(value: any) => handleSearch(
              value,
              setIsError,
              setLoading,
              setIsRefetching,
              setSearchValue,
            )
            }
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            state={{
              columnFilters,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        }

      </PageLayout>
    
    </Fragment>

  )
}

export default FaqManagementList